<template>
  <el-card shadow="nerver">
    <!-- 添加poi -->
    <div style="display:flex">
      <div>
        <el-button @click="$router.push({ name: 'before_trip_list_add' })"
                   size="mini"
                   type="primary"
                   icon="el-icon-plus"
                   plain>新建行前手册</el-button>
      </div>

    </div>
    <!-- 列表 -->
    <div>
      <el-table :data="check_list"
                style="width: 100%">
        <el-table-column prop="id"
                         label="id"
                         width="70">
        </el-table-column>
        <el-table-column prop="before_trip_title"
                         label="行前手册名称"
                         width="240">
        </el-table-column>
        <el-table-column prop="before_trip_info"
                         label="内容使用情况说明"
                         width="">
        </el-table-column>
        <el-table-column prop="before_trip_info"
                         label="管理"
                         width="80">
          <template slot-scope="item">
            <el-button type="primary"
                       size="mini"
                       icon="el-icon-edit"
                       @click="beforeTripModify(item.row.id)"
                       circle></el-button>
          </template>
        </el-table-column>

      </el-table>

    </div>
  </el-card>
</template>

<script>
import SelectDest from '../../components/common/select/SelectDest'

export default {
  name: 'before-trip-list',
  components: {
    SelectDest,
  },
  data() {
    return {
      dialogVisible: false,
      check_list: [],
      destShowBack: 15,
      dest: 15,
      addLatLngPoiId: null,
    }
  },
  mounted() {
    this.getBeforeTripList()
  },
  methods: {
    getBeforeTripList() {
      this.$http.get(`/traver/get_before_trip_list`).then((res) => {
        if (res.data.errno == '0') {
          this.check_list = res.data.data
        } else {
          this.$message({
            type: 'error',
            message: res.data.errmsg,
          })
        }
      })
    },
    beforeTripModify(val) {
      this.$router.push({
        path: `/before_trip_list_modify`,
        query: { before_trip_id: `${val}` },
      })
    },
  },
}
</script>

<style>
</style>